



















































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import HoldFileAttachments from "@/view/hold/components/HoldFileAttachments.vue";
import HoldQiDetailsForm from "@/view/hold/components/HoldQiDetailsForm.vue";
import HoldMaterialForm from "@/view/hold/components/HoldMaterialForm.vue";
import HoldSAPForm from "@/view/hold/components/HoldSAPForm.vue";
import HoldDefectForm from "@/view/hold/components/HoldDefectForm.vue";
import HoldDispositionForm from "@/view/hold/components/HoldDispositionForm.vue";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import alertMixin from "@/mixins/alert-mixin";
import screenSizeMixin from "@/mixins/screen-size-mixin";
import {mapGetters} from "vuex";
import LoadingActions from "@/store/actions/loading";
import Disposition from "@/domainObjects/hold/Disposition";


@Component({
    components: {
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
        HoldDispositionForm,
        HoldDefectForm,
        HoldSAPForm,
        HoldMaterialForm,
        HoldQiDetailsForm,
        HoldFileAttachments
    },
    mixins:[alertMixin, screenSizeMixin],
    computed: {
        ...mapGetters(['getGroups', 'getFirstName', 'getLastName']),
    }
})

export default class EditHoldTicket extends Vue {

    private ticketId:number = 0;
    private originalHoldTicketStringified: string = "";
    private holdTicket:HoldTicket = new HoldTicket();
    private ticketChanged: boolean = false;
    private headerMessage: string = "";
    private getFirstName!: string;
    private getLastName!: string;
    private busy: boolean = false;
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_swalClose!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_saveSuccess!: () => void;
    private getGroups!: string[];


    @Watch('holdTicket', { immediate: true, deep: true})
    onPropertyChanged(value:HoldTicket, oldvalue: HoldTicket){
        let newHoldTicketStringified = JSON.stringify(value);
        this.ticketChanged = this.originalHoldTicketStringified !== newHoldTicketStringified;
    }

    created() {
        this.getTicket();
    }

    getTicket(){
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.ticketId = parseInt(this.$route.params['holdTicketId']);
        TicketService.getHoldTicketById(this.ticketId).then((response)=>{
            this.holdTicket = new HoldTicket();
            this.holdTicket.initFromObject(response.data);
            this.originalHoldTicketStringified = JSON.stringify(this.holdTicket);
            this.holdTicket.loaded = true;
            if (this.holdTicket.status.desc === 'Closed') {
                if (this.getGroups.includes('admin')){
                    this.headerMessage = "Admin Editing Closed Hold Ticket #"+this.holdTicket.holdTicketId
                } else {
                    this.holdTicket.disableEditAll = true;
                    this.headerMessage = "Closed Hold Ticket #"+this.holdTicket.holdTicketId
                }
            } else {
                this.headerMessage = "Editing Hold Ticket #"+this.holdTicket.holdTicketId
            }
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{

        });
    }

    onSubmit() {
        let self = this;
        if (this.holdTicket.status.desc === 'Open') {
            this.$_alertMixin_swalConfirm('Save Ticket', null, null).then((value) => {
                if (value) {
                    self.busy = true;
                    let holdTicketJSON = JSON.stringify(self.holdTicket.toJSON());
                    TicketService.updateHoldTicket(holdTicketJSON).then((response) => {
                        if (this.holdTicket.dispositionBy &&
                            this.holdTicket.dispositionDate &&
                            this.holdTicket.disposition.id !== Disposition.ACCEPT_AS_IS &&
                            this.holdTicket.disposition.id !== Disposition.AWAITING_DISPOSITION &&
                            this.holdTicket.disposition.id !== Disposition.MEETS_SPEC
                        ) {
                            this.holdTicket.actionTrackingAvailable = true;
                        } else {
                            this.holdTicket.actionTrackingAvailable = false;
                        }
                        if (response.data === 'success') {
                            self.$_alertMixin_saveSuccess();
                            // @ts-ignore
                            this.$router.push({name: 'hold-tickets', params: {updatedTicket: this.holdTicket, updatedTicketType:'updated'}})
                        } else {
                            alert("ticket not saved! Unable to save the current ticket")
                        }
                        self.busy = false;
                    }).catch((error) => {
                        alert(error);
                    });
                }
            })
        } else {
            this.holdTicket.closedBy = this.getFirstName + ' ' + this.getLastName;
            this.holdTicket.closedDate = Date.now();
            this.$_alertMixin_swalClose('Close Ticket?', null, null).then((value) => {
                if (value) {
                    let holdTicketJSON = JSON.stringify(self.holdTicket.toJSON());
                    TicketService.closeHoldTicket(holdTicketJSON).then((response) => {
                        self.$_alertMixin_saveSuccess();
                        // @ts-ignore
                        this.$router.push({name: 'hold-tickets', params: {updatedTicket: this.holdTicket, updatedTicketType:'closed'}})
                    }).catch((error) => {
                        alert(error);
                    });
                }
            })
        }
    }

    onReset() {
        this.holdTicket.loaded = false;
        this.$nextTick(()=>{
            this.getTicket();
        })
    }

    editAll() {
        this.holdTicket.disableEditMaterial = !this.holdTicket.disableEditMaterial;
    }

    validDefectSelected(){
        if (this.holdTicket.defect.id === 5 || this.holdTicket.defect.id === 8 || this.holdTicket.defect.id === 9){
            return false
        }
        return true
    }
}

